import React, { useMemo } from "react";
import { Dialog, DialogContent, Typography, Button } from "@material-ui/core";
import { CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "../../langs/useTranslation";
import { handleS3pathDownload, updateNotificationAPI } from "@/apis/announcementApi";
import useStyles from "../../styles/commonStyle";
import moment from "dayjs";
import getFileIcon from "@/helpers/fileIcon";

export const notificationColorMap = {
  "Alarm Notification": {
    color: "#F7862A",
    backgroundColor: "#F8EDE6"
  },
  "Platform Notification": {
    color: "#00AFC6",
    backgroundColor: "rgba(0,175,198,0.1)"
  }
};

const NotificationDetailDialog = props => {
  const classes = useStyles();
  const { onClose, open, currentNotiItem, hasConfirmBtn } = props;
  const { t } = useTranslation("common");

  const tagTextMap = {
    "Alarm Notification": t({ defaultMessage: "报警通知" }),
    "Platform Notification": t({ defaultMessage: "平台公告" })
  };

  const notificationTag = () => {
    const tagStyle =
      notificationColorMap[notifyInfo.type] ||
      notificationColorMap["Platform Notification"];
    const tagText =
      tagTextMap[notifyInfo.type] || tagTextMap["Platform Notification"];

    return (
      <div
        style={{
          padding: "3px 16px",
          fontSize: "12px",
          borderRadius: 12,
          height: 24,
          ...tagStyle
        }}
      >
        {tagText}
      </div>
    );
  };

  const notifyInfo = currentNotiItem.json || {};

  const fileList = useMemo(() => {
    try {
      return JSON.parse(notifyInfo.s3Path || "[]") || [];
    } catch (e) {
      return [];
    }
  }, [notifyInfo.s3Path]);

  const handleOnConfirm = async (noti) => {
    await updateNotificationAPI([noti.id])
    onClose(true)
  }

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="notification-dialog-title"
      open={open}
      width={500}
      className={classes.dialog}
    >
      <div>
        <div
          style={{
            fontWeight: 500,
            fontSize: 16,
            marginBottom: 19,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          {t({ defaultMessage: "消息通知" })}
          <CloseOutlined onClick={onClose} />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            style={{
              fontWeight: 400,
              fontSize: 12,
              color: "#91919F"
            }}
          >
            {currentNotiItem.fromUserName}
            {currentNotiItem.createdAt ? "- " : ""}
            {currentNotiItem.createdAt
              ? moment(Number(currentNotiItem.createdAt)).format(
                  "YYYY-MM-DD HH:mm:ss"
                )
              : null}
          </div>
          {notificationTag()}
        </div>
      </div>
      <DialogContent
        style={{
          minWidth: 500,
          maxWidth: 700,
          backgroundColor: "#F8F9FC",
          borderRadius: 10,
          marginTop: 18,
          padding: 24
        }}
      >
        <Typography variant="h5" className={classes.notiDialogMainMsg}>
          <span
            style={{ fontSize: 16, fontWeight: 500 }}
            dangerouslySetInnerHTML={{ __html: notifyInfo.title }}
          />
        </Typography>
        <Typography
          style={{ fontSize: 14 }}
          variant="body2"
          color="textPrimary"
          component="div"
          className={classes.allNotiMemos}
        >
          <span dangerouslySetInnerHTML={{ __html: notifyInfo.message }} />
        </Typography>

        {notifyInfo.type === "Platform Notification" && (
          <>
            <Typography
              variant="body2"
              color="textPrimary"
              className={classes.allNotiMemos}
            >
              {t({ defaultMessage: "开始时间" })}:
              {moment(Number(notifyInfo.startTime)).format(
                "YYYY-MM-DD HH:mm:ss"
              )}
            </Typography>
            <Typography
              variant="body2"
              color="textPrimary"
              className={classes.allNotiMemos}
            >
              {t({ defaultMessage: "结束时间" })}:
              {moment(Number(notifyInfo.endTime)).format("YYYY-MM-DD HH:mm:ss")}
            </Typography>
          </>
        )}

        {fileList.length > 0 && (
          <div
            style={{
              height: 1,
              border: "1px solid rgba(0,178,201,0.2)",
              marginTop: 24,
              marginBottom: 15
            }}
          />
        )}
        {fileList.length > 0 && (
          <Typography
            variant="body2"
            color="textPrimary"
            className={classes.allNotiMemos}
          >
            <>
              {fileList.map(file => {
                const Icon = getFileIcon(file.name);
                return (
                  <div
                    style={{ cursor: "pointer", color: "#00AFC6" }}
                    key={file.s3Path}
                    onClick={() => {
                      handleS3pathDownload(file.s3Path);
                    }}
                  >
                    <span style={{ fontSize: 16, marginRight: 10, height: 16 }}>
                      <Icon />
                    </span>
                    {file.name}
                    {/* {index === fileList.length - 1 ? "" : "、"} */}
                  </div>
                );
              })}
            </>
          </Typography>
        )}
      </DialogContent>
      { hasConfirmBtn && (
        <Button style={{marginTop: 16, marginLeft: "auto"}} onClick={() => handleOnConfirm(currentNotiItem)}>
          {t({defaultMessage: "确认，以后不再显示"})}
        </Button>
      )}
    </Dialog>
  );
};

export default NotificationDetailDialog;
